export default __webpack_public_path__ + "static/media/moltensteelslash3.53d786c5.png";